import axios from 'axios'
import { EXCLUIR_PRECO } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function excluirRota (cod, idEmpresa) {
  const url = `${URL}/preco/${cod}/empresa/${idEmpresa}/excluir/`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: EXCLUIR_PRECO,
        payload: response

      })
  );
}
